import z from 'zod'
import { CreateOrgInputSchema } from '@buyerflo/core/schemas/createOrg'

export const UserDetailsSchema = z
    .object({
        firstName: z.string().min(1, 'First name is required'),
        lastName: z.string().min(1, 'Last name is required'),
        email: z.string().email('Please enter a valid email address'),
        password: z.string().min(8, 'Password must be at least 8 characters'),
        confirmPassword: z.string().min(1, 'Please confirm your password'),
    })
    .refine(data => data.password === data.confirmPassword, {
        message: 'Passwords do not match',
        path: ['confirmPassword'],
    })

export type UserDetailsFormData = z.infer<typeof UserDetailsSchema>

export const EmailVerificationSchema = z.object({
    code: z.string().length(6, 'Please enter the 6-digit code'),
})

export type EmailVerificationFormData = z.infer<typeof EmailVerificationSchema>

// Re-use the backend schema so signup and API validation stay aligned
export const OrgDetailsSchema = CreateOrgInputSchema

export type OrgDetailsFormData = z.infer<typeof OrgDetailsSchema>
